// fsiCalc.js — wrapper around labEngine.fsi() (IS 2720 Part 40:1977) with reading sanity checks.

import { fsi } from "../labEngine";


const CLAUSE = 'IS 2720-40:1977';
const CYLINDER_CC = 100; // the test uses 100 ml graduated cylinders

// specimens = [{ vdCc, vkCc }], settleHours
export function computeFSI({ specimens, settleHours }) {
  const issues = [];
  let bad = false;
  const block = (code, msg) => { bad = true; issues.push({ level: 'block', code, clause: CLAUSE, msg }); };

  specimens.forEach((s, i) => {
    const tag = `Specimen ${['I', 'II', 'III'][i] || i + 1}`;
    [['Vd (water)', s.vdCc], ['Vk (kerosene)', s.vkCc]].forEach(([name, v]) => {
      if (!(v > 0)) block('READING', `${tag}: ${name} must be above 0`);
      else if (v > CYLINDER_CC) block('READING', `${tag}: ${name} cannot be more than ${CYLINDER_CC} cc (cylinder capacity)`);
    });
    if (s.vdCc > 0 && s.vkCc > 0 && s.vdCc < s.vkCc)
      issues.push({ level: 'warn', code: 'VD_LT_VK', clause: CLAUSE,
        msg: `${tag}: Vd is less than Vk, so the index is negative — check the readings` });
  });
  if (bad) return { result: null, issues };

  const out = fsi({ specimens, settleHours });
  return { result: out.result, issues: [...issues, ...out.issues] };
}
